import { Skeleton, Stack, Typography } from '@mui/material';

import { useOrgSharedEndpointsInferenceVolume } from '../hooks';
import { InferenceVolumeProps } from './types';

function InferenceVolume({ id }: InferenceVolumeProps) {
  const { data, loading } = useOrgSharedEndpointsInferenceVolume(id);
  return (
    <Stack direction="row" gap={1} alignItems="center" minHeight={25}>
      {loading && !data ? (
        <Skeleton variant="text" width={100} height={20} />
      ) : (
        <>
          <Typography variant="h5">
            {data?.instantSharedEndpointsMetrics.inferenceVolume}
          </Typography>
          <Typography variant="body1" color="text.muted">
            /hour
          </Typography>
        </>
      )}
    </Stack>
  );
}

export default InferenceVolume;
